/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TeamUser } from './TeamUser.js';
import {
    TeamUserFromJSON,
    TeamUserFromJSONTyped,
    TeamUserToJSON,
} from './TeamUser.js';

/**
 * 
 * @export
 * @interface GetTeamUsersResponse
 */
export interface GetTeamUsersResponse {
    /**
     * 
     * @type {Array<TeamUser>}
     * @memberof GetTeamUsersResponse
     */
    data?: Array<TeamUser>;
    /**
     * 
     * @type {number}
     * @memberof GetTeamUsersResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamUsersResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamUsersResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetTeamUsersResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetTeamUsersResponse interface.
 */
export function instanceOfGetTeamUsersResponse(value: object): boolean {
    return true;
}

export function GetTeamUsersResponseFromJSON(json: any): GetTeamUsersResponse {
    return GetTeamUsersResponseFromJSONTyped(json, false);
}

export function GetTeamUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TeamUserFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetTeamUsersResponseToJSON(value?: GetTeamUsersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TeamUserToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

